import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Carrier } from "../models/Carrier";

export const getCarriers = async (
	params: { partId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.partId) parameters.push({ name: "PartId", value: params.partId });

	const resp = await apiService.callV2(
		"[M2].[GetCarriers]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Carrier[];
	} else {
		throw new Error(resp.message || "Error fetching carriers");
	}
};
export const upsertCarrier = async (carrier: Carrier) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "PartId", value: carrier.PartId },
		{ name: "PartName", value: carrier.PartName },
		{ name: "LocationId", value: carrier.LocationId },
		{ name: "Comments", value: carrier.Comments },
		{ name: "AssemblyStatusCode", value: carrier.CarrierStatusCode },
	];

	const resp = await apiService.callV2("[M2].[UpsertCarrier]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting carriers");
	}
};

export const deleteCarrier = async (partIds: string | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartIds", value: partIds }];

	const resp = await apiService.callV2("[M2].[DeleteCarrier]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting carrier");
	}
};
